//importation de bootstrap
import "bootstrap/dist/css/bootstrap-grid.css";
import "bootstrap/dist/css/bootstrap-reboot.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
//importation de react
//importation de fontawesome
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./../styles/nav.css";

export default function Nav() {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          backgroundColor: "#303033",
          height: "40px",
          borderBottom: "1px solid #ffffff59",
        }}
      >
        <div className="container-fluid">
          {/* Contenu de la navbar */}
          <div className="d-flex flex-row flex-wrap w-100 justify-content-between align-items-center py-2">
            {/* Localisation - Ligne supérieure sur mobile */}
            <div className="d-flex align-items-center mb-2 mb-lg-0 mx-2">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="text-primary me-2"
              />
              <span className="text-white small">
                Ancien 6eme Étoudi, Yaoundé-Cameroun
              </span>
            </div>

            {/* Réseaux sociaux - Centré sur mobile */}
            <div className="d-flex justify-content-center my-2 my-lg-0 mx-2">
              <a href="/" className="text-decoration-none mx-2">
                <FontAwesomeIcon icon={faFacebook} className="text-primary" />
              </a>
              <a href="/" className="text-decoration-none mx-2">
                <FontAwesomeIcon icon={faTwitter} className="text-primary" />
              </a>
              <a href="/" className="text-decoration-none mx-2">
                <FontAwesomeIcon icon={faInstagram} className="text-primary" />
              </a>
            </div>

            {/* Email - Ligne inférieure sur mobile */}
            <div className="d-flex align-items-center mt-2 mt-lg-0 mx-2">
              {/* Téléphone - Ligne inférieure sur mobile */}
              <div className="d-flex align-items-center mb-2 mb-lg-0 mx-2">
                <FontAwesomeIcon icon={faPhone} className="text-primary me-2" />
                <span className="text-white small">+(237) 673 250 328</span>
              </div>
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-primary me-2"
              />
              <span className="text-white small">
                contact@transfoafricainc.com
              </span>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
